{
  "name": "hypecast-master-admin--webapp",
  "version": "0.0.60",
  "private": true,
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || >=26.0.0"
  },
  "scripts": {
    "build": "ng build --configuration=${ANGULAR_ENVIRONMENT}",
    "postbuild": "node scripts/generate-version.mjs prod",
    "prestart": "node scripts/generate-version.mjs dev",
    "start": "ng serve --configuration=development",
    "lint": "npm run lint:ts -s && npm run lint:styles -s && npm run lint:templates -s",
    "lint:ts": "eslint \"src/**/*.ts\" \"src/**/*.html\"",
    "lint:ts:fix": "eslint \"src/**/*.ts\" \"src/**/*.html\" --fix",
    "lint:styles": "stylelint \"src/**/*.scss\" --custom-syntax postcss-scss",
    "lint:templates": "htmlhint \"src\" --config .htmlhintrc",
    "test": "ng test --watch=false",
    "test:watch": "ng test",
    "test:coverage": "ng test --watch=false --coverage",
    "test:ci": "npm run lint -s && npm run test:coverage -s",
    "format:check": "prettier --check .",
    "format:fix": "prettier --write .",
    "prepare": "husky"
  },
  "lint-staged": {
    "*.ts": [
      "eslint --fix"
    ],
    "*.html": [
      "prettier --write"
    ],
    "*.scss": [
      "prettier --write"
    ]
  },
  "dependencies": {
    "@angular/cdk": "^22.2.1",
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/material": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@angular/service-worker": "^22.2.1",
    "@datadog/browser-logs": "^7.13.0",
    "@datadog/browser-rum": "^7.13.0",
    "@datadog/browser-rum-angular": "^7.13.0",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^4.0.0",
    "@rxweb/types": "^1.0.6",
    "@swimlane/ngx-charts": "^20.1.0",
    "@types/file-saver": "^2.0.5",
    "dayjs": "^1.11.20",
    "express": "*",
    "file-saver": "^2.0.5",
    "howler": "^2.2.3",
    "material-design-icons": "^3.0.1",
    "ngx-image-cropper": "^9.1.6",
    "rxjs": "^7.5.6",
    "tslib": "^2.2.0"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@angular/language-service": "^22.2.1",
    "@biesbjerg/ngx-translate-extract": "^7.0.4",
    "@eslint/js": "^9.39.2",
    "@ngx-rocket/scripts": "^4.0.0",
    "@tailwindcss/postcss": "^4.0.0",
    "@types/howler": "^2.2.7",
    "@types/node": "^22.19.11",
    "@vitest/coverage-v8": "^4.0.18",
    "angular-eslint": "^22.1.0",
    "eslint": "^9.39.2",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-rxjs-x": "^0.9.2",
    "eslint-plugin-security": "^3.0.1",
    "htmlhint": "^1.9.1",
    "https-proxy-agent": "^3.0.1",
    "husky": "^9.1.7",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "lint-staged": "^16.2.7",
    "postcss": "^8.5.3",
    "postcss-loader": "^7.0.1",
    "postcss-scss": "^4.0.9",
    "prettier": "^3.8.1",
    "stylelint": "^17.15.0",
    "tailwindcss": "^4.0.0",
    "ts-node": "^10.9.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.68.0",
    "vitest": "^4.0.18",
    "webpack": "^5.96.1"
  }
}
